import axiosInstance from "@/api/axiosInstance";
import { FetchEmailActivityLogDetailResponse } from "./types";

export const fetchEmailCampaignActivityLogDetail = async (
  messageId: string
): Promise<FetchEmailActivityLogDetailResponse> => {
  const response = await axiosInstance.get<FetchEmailActivityLogDetailResponse>(
    `/api/private/email-campaign-activity-logs/${messageId}/detail`
  );
  return response.data;
};
